/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import LangContext from "../contextProvider/LangContext";
import GenericModal from "./GenericModal";
import { Job, OutputType, ProcessType, User } from "../JmReact";
import { Button, Checkbox, Col, Form, Input, message, Modal } from "antd";
import ResponsiveTable from "./ResponsiveTable";
import moment from "moment";
import TableLineIcons from "./TableLineIcons";
import { Row } from "antd/es/grid";
import GenericSelector from "./GenericSelector";
import DateTimePicker from "./DateTimePicker";


class ModalDocServices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            modalDataset: [],
            modalEdit: null,
            modalReadOnly: false,
        }

        this.selectors = [
            { id: "SERVICES_TYPES_LIST", api: "services_types_list" },
            { id: "CUSTOMER_BUSINESS_BRANCHES_LIST", api: "customer_business_branches_list" },
        ]

        this.selectors.forEach(x => {
            if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector }
        })
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.apiSelector(0)
    }

    componentDidUpdate(p) {
        if (p.record !== this.props.record) {
            this.apiGetDataset()
            this.apiSelector(1, { cust: this.props.record?.custID })
        }
    }

    apiSelector = (index, filters) => {
        const { id, api } = this.selectors[index]
        this.props.dataActions.genericSelectorRefreshDataset(
            id, this.props.user.companyCode, this.props.user.token, api, filters);
    }


    sendAPI = (script, data, sCall, eCall) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType["OUTPUT_TYPE_DATA"], ProcessType["PROCESS_TYPE_SYNC"]);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCall, eCall);
    };

    apiGetDataset = () => {
        const { DocumentNumber, DocumentTypeId, DocumentPOSID } = this.props.record ?? {}
        const gt = this.getText
        this.sendAPI("get_services_document_lines", { DocumentNumber, DocumentTypeId, DocumentPOSID }, ob => {
            let modalDataset = []
            let fullData = ob.data ?
                ob.data.split("\r").map(x => {
                    let y = x.split("\f")
                    return {
                        sID: y[0],
                        sBranchID: y[1],
                        sBranchName: y[2],
                        sOpenDatetime: y[3],
                        sOpenUser: y[4],
                        sOpenUserName: y[5],
                        sItemCode: y[6],
                        sItemSN: y[7],
                        sDesc: y[8],
                        sQty: y[9],
                        sFromDate: y[10],
                        sToDate: y[11],
                        sTypeID: y[12],
                        sRemark: y[13],
                        sIsActive: y[14],
                        sCloseDatetime: y[15],
                        sCloseUser: y[16],
                        sCloseUserName: y[17],
                        sTypeFilter: y[18],
                    }
                })
                : []

            fullData.forEach(x => {
                if (x.sQty > 50) {
                    this.modalConfirm(`${gt(20812)} ${x.sDesc} ${gt(20813)} ${x.sQty}, ${gt(20825)}`)
                } else if (x.sQty > 1) {
                    for (let z = 0; z < x.sQty; z++) { modalDataset.push({ ...x, sQty: '1' }) }
                } else {
                    modalDataset.push(x)
                }
            })

            if (!modalDataset.length) {
                this.modalConfirm(gt(20815))
            } else {
                this.setState({ modalOpen: true, modalDataset: modalDataset.map((x, index) => { return { ...x, index, key: index } }) })
            }
        })
    }

    modalConfirm = (content) => {
        Modal.confirm({
            content,
            iconType: 'exclamation-circle',
            okButtonProps: { style: { display: 'none' } },
            cancelText: this.getText(20814),
            onOk() { },
            onCancel() { },
        })
    }

    onCancel = () => {
        this.setState({
            modalOpen: false,
            modalDataset: []
        })
    }

    formItemEditField = (label, field, label2, field2) => {
        if (label2 && field2) {
            return (<Row>
                <Col span={window.innerWidth > 800 ? 12 : 24}>
                    <Form.Item label={label} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>{this.editField(field)}</Form.Item>
                </Col>
                <Col span={window.innerWidth > 800 ? 12 : 24}>
                    <Form.Item label={label2} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>{this.editField(field2)}</Form.Item>
                </Col>
            </Row>)
        } else {
            return (<Form.Item label={label} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>{this.editField(field)}</Form.Item>)
        }
    }

    editField = (field) => {
        const modalEdit = this.state.modalEdit ?? {}
        const value = modalEdit[field]
        const onChange = e => { this.setState({ modalEdit: { ...this.state.modalEdit, [field]: e } }) }
        const disabled = modalEdit.sID > 0 || this.state.modalReadOnly

        switch (field) {
            case 'sBranchID':
                return (<GenericSelector {...this.props} id={"CUSTOMER_BUSINESS_BRANCHES_LIST"} {...{ value, onChange, disabled }} />)
            case 'sTypeID':
                let filterList = disabled ? undefined : modalEdit.sTypeFilter?.split(",");
                return (<GenericSelector {...this.props} id={"SERVICES_TYPES_LIST"} {...{ value, onChange, disabled, filterList }} />)
            case 'sOpenDatetime': case 'sCloseDatetime':
                return value ? moment(value).format("DD/MM/YYYY") : ""
            case 'sFromDate': case 'sToDate':
                return modalEdit.sID > 0 ? value ? moment(value).format("DD/MM/YYYY") : "" : (<DateTimePicker format="DD/MM/YYYY" {...{ value, onChange, disabled }} />)
            case 'sItemSN': case 'sDesc':
                return modalEdit.sID > 0 ? value : (<Input {...{ value, disabled }} onChange={e => { onChange(e.target.value) }} />)
            case 'sRemark':
                return modalEdit.sID > 0 ? value : (<Input.TextArea {...{ value, disabled }} onChange={e => { onChange(e.target.value) }} />)
            case 'sIsActive':
                return (<Checkbox checked={value == 1} onChange={e => { onChange(e.target.checked) }} disabled={(modalEdit.sID > 0 && value != 1) || this.state.modalReadOnly} />)
            default: return value
        }
    }

    onSave = () => {
        const { custID, DocumentNumber, DocumentTypeId, DocumentPOSID } = this.props.record

        this.sendAPI("create_edit_services",
            this.state.modalDataset.map(x => {
                const { sID, sBranchID, sItemCode, sItemSN, sDesc, sQty, sFromDate, sToDate, sTypeID, sRemark, sIsActive } = x;
                return {
                    sID,
                    sCustomerID: custID,
                    sBranchID,
                    sDocumentNumber: DocumentNumber,
                    sDocumentType: DocumentTypeId,
                    sDocumentPOS: DocumentPOSID,
                    sItemCode,
                    sItemSN,
                    sDesc,
                    sQty,
                    sFromDate,
                    sToDate,
                    sTypeID,
                    sRemark,
                    sIsActive
                }
            }), () => {
                message.success(this.getText(20851))
                this.onCancel()
            })
    }

    onSaveRow = () => {
        const { modalEdit, modalDataset } = this.state
        let dataset = modalDataset.map((x, i) => (i == modalEdit.index) ? modalEdit : x)
        this.setState({ modalEdit: null, modalDataset: dataset, modalReadOnly: false })
    }

    render() {
        const gt = this.getText
        const render = t => t
        const renderDate = t => t ? moment(t).format("DD/MM/YYYY") : ""
        const renderCB = t => (<Checkbox checked={t == 1} />)
        const renderType = t => this.props.data.SERVICES_TYPES_LIST.dataset.find(f => f.code == t)?.name
        const renderEditCol = (t, r) => {
            return (<TableLineIcons
                genericIcons={[
                    { type: "edit", onClick: () => { this.setState({ modalEdit: r, modalReadOnly: false }) }, tooltip: gt(20852), disabled: r.sID > 0 && r.sIsActive != '1' },
                    { type: "eye", onClick: () => { this.setState({ modalEdit: r, modalReadOnly: true }) } , tooltip: gt(20853)}
                ]}
            />)
        }
        // const colSpan = (w,c) => (<Col span={window.innerWidth > 800 ? })
        const { custID, DocumentCustomerName, DocTypeName, DocumentNumber, DocumentPOSID } = this.props.record ?? {}
        const title = (<span>
            {custID} - {DocumentCustomerName}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {DocTypeName} {DocumentNumber} {gt(20811)}: {DocumentPOSID}
        </span>)

        return (<GenericModal
            visible={this.state.modalOpen}
            onCancel={this.onCancel}
            title={title}
            footer={[
                <Button onClick={this.onCancel}>{gt(20845)}</Button>,
                <Button type="primary" onClick={this.onSave}>{gt(20844)}</Button>,
            ]}>
            <ResponsiveTable
                tableOnly
                dataSource={this.state.modalDataset}
                columns={[
                    { title: gt(20816), key: "sBranchName", dataIndex: "sBranchName", width: "15%", render },
                    { title: gt(20817), key: "sItemCode", dataIndex: "sItemCode", width: "10%", render },
                    { title: gt(20818), key: "sItemSN", dataIndex: "sItemSN", width: "10%", render },
                    { title: gt(20819), key: "sDesc", dataIndex: "sDesc", width: "20%", render },
                    { title: gt(20820), key: "sFromDate", dataIndex: "sFromDate", width: "8%", render: renderDate },
                    { title: gt(20821), key: "sToDate", dataIndex: "sToDate", width: "8%", render: renderDate },
                    { title: gt(20822), key: "sTypeID", dataIndex: "sTypeID", width: "16%", render: renderType },
                    { title: gt(20823), key: "sIsActive", dataIndex: "sIsActive", width: "5%", render: renderCB },
                    { title: gt(20824), width: "8%", render: renderEditCol }
                ]}
                pagination={{ pageSize: 10 }}
            />
            <GenericModal
                visible={this.state.modalEdit}
                onCancel={() => { this.setState({ modalEdit: null, modalReadOnly: false }) }}
                title={title}
                width={800}
                footer={[
                    <Button onClick={() => { this.setState({ modalEdit: null, modalReadOnly: false }) }}>{gt(20843)}</Button>,
                    <Button type="primary" onClick={this.onSaveRow}>{gt(20842)}</Button>,
                ]}>
                {this.formItemEditField(this.getText(20826), 'sID')}
                {this.formItemEditField(this.getText(20827), 'sBranchID')}
                {this.formItemEditField(this.getText(20828), 'sOpenDatetime', this.getText(20829), 'sOpenUserName')}
                {this.formItemEditField(this.getText(20830), 'sItemCode', this.getText(20831), 'sItemSN')}
                {this.formItemEditField(this.getText(20832), 'sDesc')}
                {this.formItemEditField(this.getText(20833), 'sFromDate', this.getText(20834), 'sToDate')}
                {this.formItemEditField(this.getText(20835), 'sTypeID')}
                {this.formItemEditField(this.getText(20836), 'sRemark')}
                {this.formItemEditField(this.getText(20837), 'sIsActive')}
                {this.formItemEditField(this.getText(20838), 'sCloseDatetime', this.getText(20839), 'sCloseUserName')}
            </GenericModal>
        </GenericModal>)
    }
}

export default ModalDocServices